import { get } from "lodash";
import { IAppState } from "../index";
import { initialState } from "./reducer";

export const getOffHourHighlighting = (state: IAppState): boolean =>
  get(state, "aggregator.offHourHighlighting", initialState.offHourHighlighting);
